import { useSidebar } from '@quadminds/mindkit';
import * as React from 'react';
import { Outlet } from 'react-router-dom';
import SettingsSidebar from '../SettingsSidebar/SettingsSidebar';

export function Layout() {
    const { setOpen } = useSidebar();

    React.useEffect(() => {
        setOpen(false);
    }, []);

    return (
        <div className="flex h-full w-full">
            <div className="w-64 h-full">
                <SettingsSidebar />
            </div>
            <div className="flex-1 overflow-y-auto">
                <Outlet />
            </div>
        </div>
    );
}

export default Layout;
